/** Mirrors kilobyte.zookeeper.model.enums.InvoiceNumberingScheme on the backend, minus NONE (that's the settings switch being off, not a dropdown choice) - kept in sync manually. */
export const INVOICE_NUMBERING_SCHEMES = [
  { key: "CROATIA", labelKey: "InvoiceSchemeCroatia" },
];
